module.exports = __webpack_public_path__ + "static/img/3-6.3.5.013e5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/5/3-6.3.5.png
// module id = DDrv
// module chunks = 0